<div
  echarts
  class="chart"
  [style.--chart-height.px]="chartHeight()"
  [options]="adaptedOptions()"
  [initOpts]="initOpts"
></div>

<div class="sliders-panel">
  <dojo-slider
    param="λ"
    [min]="0.1"
    [max]="20"
    [step]="0.1"
    [value]="lambda()"
    [editable]="true"
    color="orange"
    (valueChange)="onLambdaChange($event)"
  />
</div>

<div class="stats-panel">
  <span class="stat">E(X) = {{ mean() | number: '1.1-1' }}</span>
  <span class="stat">Var(X) = {{ variance() | number: '1.1-1' }}</span>
</div>
